import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { IconComponent } from '../../../shared/components/icon/icon.component';

@Component({
  selector: 'app-unsaved-changes-dialog',
  imports: [MatButtonModule, MatDialogModule, IconComponent],
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrl: './unsaved-changes-dialog.component.scss',
})
export class UnsavedChangesDialogComponent {
  private store = inject(Store);
  private dialogRef = inject(MatDialogRef<UnsavedChangesDialogComponent>);
  private data = inject(MAT_DIALOG_DATA);

  continue() {
    // Close with `true` so callers awaiting afterClosed() (the unsaved-changes route guard)
    // can tell Discard apart from Cancel/Escape, which close with no result.
    this.dialogRef.close(true);
    if (this.data.continueAction !== null) {
      this.store.dispatch(this.data.continueAction);
    }
  }
}
